import axios from 'axios';

const REQUEST_MAX_ATTEMPTS = 4;
const REQUEST_RETRY_BASE_DELAY = 1000; // Backoff: 1s, 2s, 4s.

const delay = (ms) => new Promise(resolve => setTimeout(resolve, ms));

const isRetryableRequestError = (error) => {
    // Don't retry cancellations.
    if (axios.isCancel(error))
        return false;

    // Retry only pure network errors or timeouts (no response at all).
    // Any response from the server fails fast to avoid adding load to a struggling backend.
    return !error.response;
};

export const requestWithRetry = async (requestFactory) => {
    for (let attempt = 1; ; attempt++) {
        try {
            return await requestFactory();
        } catch (error) {
            if (!isRetryableRequestError(error) || attempt >= REQUEST_MAX_ATTEMPTS)
                throw error;

            const retryDelay = REQUEST_RETRY_BASE_DELAY * Math.pow(2, attempt - 1);
            console.warn(`Request failed (attempt ${attempt} of ${REQUEST_MAX_ATTEMPTS}), retrying in ${retryDelay}ms...`, error);
            await delay(retryDelay);
        }
    }
};
